<template>
  <div class="app" id="app">
    <navbar></navbar>

    <vue-snotify></vue-snotify>

    <transition name="fade" mode="out-in">
      <router-view :clickButton="clickButton"></router-view>
    </transition>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
@import "https://fonts.googleapis.com/css?family=Roboto:400,500";
@import "https://www.amcharts.com/lib/3/plugins/export/export.css";
@import "https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css";
@import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
@import "./files/assets/pages/waves/css/waves.min.css";
@import "./files/assets/icon/themify-icons/themify-icons.css";
@import "./files/assets/icon/font-awesome/css/font-awesome.min.css";

@import "./files/assets/pages/chart/radial/css/radial.css";
@import "./files/assets/css/style.css";
@import "./files/assets/pages/hover-effect/normalize.css";
@import "./files/assets/pages/hover-effect/set2.css";
@import "assets/icons/firerisks-icon.css";

@import "assets/css/fileicons.css";
@import "assets/css/main.css";
@import "assets/css/darklight-blue.min.css";
@import "assets/css/widgets.min.css";
@import "assets/css/site.css";
@import "~vue-snotify/styles/material.css";
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Ubuntu:wght@400;500;700&display=swap");

.card {
  box-shadow: 0 5px 10px 0 rgba(68, 138, 255, 0.4) !important;
}
.btn {
  text-transform: none !important;
}
.snotify-rightBottom {
  bottom: 65px !important;
}
.app {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--white-color);
}
</style>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Navbar from "./components/layout/Navbar";
export default {
  name: "app",
  metaInfo: {
    title: "Fire Risks | Расчет пожарных рисков на производственных объектах",
  },
  components: {
    Navbar,
  },
  data() {
    return {
      context: "app context",
      loaded: false,
      coreData: {},
      clickButton: {},
    };
  },
  mounted() {
    var _this = this;
    // Set up $auth.ready with other arbitrary loaders (ex: language file).
    setTimeout(function () {
      _this.loaded = true;
    }, 500);
  },
  created() {
    this.$moment.locale("ru");
    this.$moment.tz.setDefault("UTC");
    this.$auth.ready(function () {
      console.log("ready " + this.context);
    });
    let that = this;
    document.addEventListener("keyup", function (evt) {
      if (evt.key === "Escape") {
        that.clickButton = { id: Math.random(), action: "esc" };
      }
    });
  },
  methods: {
    logout() {
      this.$auth.logout({
        makeRequest: true,
        redirect: { name: "Index" },
        success() {
          console.log("success " + this.context);
        },
        error() {
          console.log("error " + this.context);
          alert("Возникла ошибка");
        },
      });
    },
    unimpersonate() {
      this.$auth.unimpersonate({
        success() {
          console.log("success " + this.context);
        },
        error() {
          console.log("error " + this.context);
        },
      });
    },
  },
};
</script>
